import { defineStore } from "pinia";

 
export const newspaperStore = defineStore("newspaperStore", () => {
  
   

  const { $apiAuth, $api, $apiAxios } = useNuxtApp()

  const newspapers = ref([]);
  const categories = ref([]);


  function initCategories(data) {
    categories.value = data;
  }

  
  async function CreateNewspaper(
    input
  ){
    try {
      
 
     const data = await $apiAuth('/api/newspaper/create',{
      method: 'POST',
      body:{
        ...input
      }
     })

      return {
        success: true,
        data: data?.data,
        errorValidation: {}
      };
      
    } catch (error) {
 
      return {
        success: false,
        status: error.response?.status,
        data: null,
        errorValidation: error?.response?._data?.errors
      };
    }
  }
async function createNewspaperRetail(
    input
  ){
    try {

     const data = await $apiAuth('/api/newspaper/retail/create',{
      method: 'POST',
      body:{
        ...input
      }
     })
 

      return {
        success: true,
        data: data?.data,
        errorValidation: {}
      };
      
    } catch (error) {
 
 
      return {
        success: false,
        status: error.response?.status,
        data: null,
        errorValidation: error?.response?._data?.errors
      };
    }
  }
  async function getNewspapes(
    input
  ){
    try {
      const data = await $apiAuth('/api/newspaper/paginate',{
        method: 'GET',
        params:{
          ...input
        }
       })

       return {
          success: true,
          data: data?.data,
        };
       
    } catch (error) {
       


      return {
        success: false,
        status: error.response?.status,
        data: null,
      };
    }
    
   }

  async function DeleteNewspaper(
    id
  ){
    try {
    
      const data = await $apiAuth(`/api/newspaper/delete/${id}`,{
        method: 'DELETE',      
       })
      
        return {
          success: true,
          data: data?.data,
        };
      
    } catch (error) {

      return {
        success: false,
        status: error.response?.status,
        data: null,
      };
    }
    
  }
  
  async function UpdateNewspaper(
    input
  ){
     

    try {
          
      const data = await $apiAuth(`/api/newspaper/update`,{
        method: 'PUT',      
        body:{
          ...input
        }
       })
  
       
      return {
        success: true,
        data: data?.data,
      };
     
    } catch (error) {
      
      return {
        success: false,
        status: error.response?.status,
        data: null,
        errorValidation: error?.response?._data?.errors
      };
    }
     
  }

  async function StoreNewspaperCache(){
  try {
          
      const data = await $apiAuth('/api/newspaper/cache/set',{
        method: 'GET'
       })
     
      return {
        success: data?.success,
        data: data?.data,
      };
     
    } catch (error) {


      return {
        success: false,
        status: error.response?.status,
        data: null,
        errorValidation: {}
      };
    }
  }

  // async function storeNewspaperCache(){
  //   try {
          
  //     const data = await $apiAuth('/api/newspaper/cache/set',{
  //       method: 'GET'
  //      })
     
  //     return {
  //       success: data?.success,
  //       content: data?.data,
  //     };
     
  //   } catch (error) {


  //     return {
  //       success: false,
  //       status: error.response?.status,
  //       data: null,
  //       errorValidation: {}
  //     };
  //   }
     
  // }
  async function GetNewspaperCache(){
    try {
          
      const data = await $apiAuth('/api/newspaper/cache/get',{
        method: 'GET'
       })
      
      return {
        success: data?.success,
        data: data?.data,
      };
     
    } catch (error) {
 

      return {
        success: false,
        status: error.response?.status,
        data: null,
        errorValidation: {}
      };
    }
     
   }
   async function getNewspaperListing(filter){
    try {
          
      const { data } = await $apiAxios.get('/api/newspaper/listing',{
        params:{
          ...filter
        }
       })
      
      return {
        success: data?.success,
        data: data?.data,
      };
     
    } catch (error) {
 
 

      return {
        success: false,
        status: error.response?.status,
        data: null,
        errorValidation: {}
      };
    }
     
   }
   async function getNewspaperListingDetails(filter){
    try {
          
      const { data } = await $apiAxios.get('/api/newspaper/listing/details',{
        params:{
          ...filter
        }
       })
      
      return {
        success: data?.success,
        data: data?.data,
      };
     
    } catch (error) {
 
 

      return {
        success: false,
        status: error.response?.status,
        data: null,
        errorValidation: {}
      };
    }
     
   }
  return {
    // newspapers,
     categories,
    CreateNewspaper,
    // getCategories,
     getNewspapes,
     DeleteNewspaper,
      UpdateNewspaper,
      StoreNewspaperCache,
      GetNewspaperCache,
      createNewspaperRetail,
      getNewspaperListing,
      getNewspaperListingDetails
  };
});
